import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";

import Bimotor from "../../../images/modulo14/bimotor.png";
import Multicolor from "../../../images/modulo14/multicolor.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad1Actividad4.mp3";

const Actividad6 = () => {
  const infoUnidad = modulo14.content[0];
  const infoAct = modulo14.content[0].activities[4];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo14.content[0].name}: ${modulo14.content[0].activities[5].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[5].path}`,
    titlePrev: `${modulo14.content[0].name}: ${modulo14.content[0].activities[3].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[3].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      {" "}
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>
      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>Observa lo siguiente:</li>
          </ul>
          <div className="my-4 p-4">
            <p className="ps-5">
              <strong>Bimotor = bi + motor: que tiene dos motores</strong>
            </p>
            <img src={Bimotor} className="bg-white img-fluid" alt="bimotor" />
            <p className="ps-5 mt-5">
              <strong>
                Multicolor = multi + color: que tiene varios colores{" "}
              </strong>
            </p>
            <img
              src={Multicolor}
              className="bg-white img-fluid"
              alt="Multicolor"
            />
          </div>
          <ul className="mt-5">
            <li>
              Ahora piensa, ¿qué significan las siguientes frases? Escríbelo.
            </li>
          </ul>
          <div className="row mt-5">
            <div className="col-md-5 ps-5">
              <div className="border-2 shadow-sm border rounded-pill p-2 text-center">
                <strong>Walter es bilingüe.</strong>
              </div>
            </div>
            <div className="col-md-12 ps-5 mt-4">
              <textarea rows={"6"} className="form-control w-100" />
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-md-5 ps-5">
              <div className="border-2 shadow-sm border rounded-pill p-2 text-center">
                <strong>El Perú es un país multilingüe.</strong>
              </div>
            </div>
            <div className="col-md-12 ps-5 mt-4">
              <textarea rows="6" className="form-control w-100" />
            </div>
          </div>
        </div>
      </div>
      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Observa lo siguiente. Pida que observen las imágenes y lean en silencio la
            explicación que se ofrece de las palabras “bimotor” y “multicolor”.
            Ofrezca una pequeña explicación de ambas palabras. Por ejemplo:
            <ul>
              <li>
                <i>
                  “La palabra “bimotor” está compuesta de dos partes: “bi” que
                  significa “dos” y la palabra “motor”. Entonces el significado
                  de la palabra “bimotor” es que tiene dos motores. Lo mismo
                  ocurre con la palabra “multicolor”. Está compuesta de dos
                  partes: “multi” que significa “muchos, varios” y “color”. Por
                  eso “multicolor” significa que tiene muchos colores”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Para asegurar la comprensión de la actividad, dé algunos ejemplos y pídales que los expliquen. Puede usar como
            ejemplos las palabras “bimestre”, “bicicleta”, “multimillonario”,
            “multiusos”. Lea la segunda indicación: Ahora piensa, ¿qué
            significan las siguientes frases? Escríbelo. Dé un tiempo para que escriban sus respuestas. Retome las respuestas. Pídales que verifiquen sus respuestas. Por
            ejemplo:
            <ul>
              <li>
                <i>
                  “¿Qué significa que Walter sea bilingüe? (Posible respuesta:
                  Significa que Walter habla dos lenguas).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué significa que el Perú sea un país multilingüe? (Posible
                  respuesta: Significa que el Perú es un país en el que se
                  hablan varias lenguas)”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
